import { Button } from "./ui/Button";
import { ArrowRight } from "lucide-react";
import CTA from "../assets/cta-Image.png";
import { openWhatsApp } from "../utils/whatsapp";

export function CTASection() {
  return (
    <section
      className="py-24 bg-[#F8F9FA] min-h-[calc(100dvh-4rem)] items-center flex relative overflow-hidden"
      content-visibility="auto"
      contain-intrinsic-size="600px"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={CTA}
          alt="Your dream study destination awaits"
          className="w-full h-full object-cover"
          loading="lazy"
          width="1920"
          height="1080"
        />
      </div>
      {/* Decorative circles */}

      <div className="max-w-4xl mx-auto p-4 sm:px-6 lg:px-8 text-center relative z-10 bg-white/10 backdrop-blur-md">
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6">
          Begin Your Study Abroad Journey
        </h2>
        <p className="text-xl text-white mb-10 max-w-2xl mx-auto">
          Get matched with top universities across the UK, USA, Canada, and
          Europe. Our expert advisors guide you through every step from
          application to visa approval.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            variant="primary"
            size="lg"
            rightIcon={<ArrowRight className="w-5 h-5" />}
            onClick={() =>
              openWhatsApp(
                "Hello! I would like to start my application with BeginPack Ltd. Please assist me with the process.\n\nName:\nEmail:\nPhone:\nService: Study Abroad / Migration / Flight Booking\nRemarks:",
              )
            }
          >
            Start Your Application
          </Button>
        </div>
      </div>
    </section>
  );
}
